import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  PASSWORD_REQUIREMENTS,
  getIconColor
} from '~/components/ui/PasswordField/utils'

import styles from './styles.module.scss'

const PasswordFieldValidations = props => {
  const {
    value,
  } = props

  return (
    <ul className={classNames({ [styles['requirements-list']]: true })}>
      {PASSWORD_REQUIREMENTS.map(requirement => {
        const { key, message, validate } = requirement
        const isValidRequirement = validate(value)
        const iconColor = getIconColor(isValidRequirement)

        return (
          <li
            key={key}
            className="flex items-center"
          >
            <FontAwesomeIcon
              icon="far fa-check"
              className={classNames({ [styles['requirements-icon']]: true })}
              color={iconColor}
            />
            {message}
          </li>
        )
      })}
    </ul>
  )
}
PasswordFieldValidations.propTypes = {
  value: PropTypes.string.isRequired,
}

const Memoized = React.memo(PasswordFieldValidations)
export default Memoized
